import { Plus, Trash2 } from "lucide-react";

const inp = "bg-slate-900 border border-slate-700 rounded px-2 py-1";

export function RecipientLists({ s }) {
  const { members, contacts, picked, flip, removeContact, form, setForm, addContact } = s;
  return (
    <div className="grid sm:grid-cols-2 gap-4 text-xs">
      <div>
        <div className="label-cap mb-2">Team members</div>
        <div className="space-y-1 max-h-40 overflow-y-auto">
          {members.map((m) => (
            <label key={m.id} className="flex items-center gap-2 cursor-pointer"><input type="checkbox" checked={picked.users.includes(m.id)} onChange={() => flip("users", m.id)} className="accent-amber-500" data-testid={`send-member-${m.id}`} /><span className="text-slate-200">{m.name}</span><span className="text-slate-500 truncate">{m.email}</span></label>
          ))}
        </div>
      </div>
      <div>
        <div className="label-cap mb-2">Project contacts (GC, owner, EOR…)</div>
        <div className="space-y-1 max-h-40 overflow-y-auto">
          {contacts.map((c) => (
            <div key={c.id} className="flex items-center gap-2">
              <label className="flex items-center gap-2 cursor-pointer flex-1 min-w-0"><input type="checkbox" checked={picked.contacts.includes(c.id)} onChange={() => flip("contacts", c.id)} className="accent-amber-500" data-testid={`send-contact-${c.id}`} /><span className="text-slate-200">{c.name}</span><span className="text-slate-500 truncate">{c.company ? `${c.company} · ` : ""}{c.email}</span></label>
              <button onClick={() => removeContact(c.id)} className="text-slate-600 hover:text-red-400" title="Remove contact" data-testid={`delete-contact-${c.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          ))}
          {!contacts.length && <div className="text-slate-600">No contacts yet.</div>}
        </div>
        <div className="mt-2 grid grid-cols-[1fr_1fr_auto] gap-1.5">
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Name" className={inp} data-testid="contact-name-input" />
          <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="email@company.com" className={inp} data-testid="contact-email-input" />
          <button onClick={addContact} className="border border-slate-700 hover:border-amber-500 rounded px-2" title="Add contact" data-testid="add-contact-button"><Plus className="w-3.5 h-3.5" /></button>
          <input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} placeholder="Company (optional)" className={`${inp} col-span-3`} data-testid="contact-company-input" />
        </div>
      </div>
    </div>
  );
}

export function SendLog({ sends }) {
  if (!sends.length) return null;
  return (
    <div className="border-t border-slate-800 pt-3" data-testid="send-log">
      <div className="label-cap mb-2">Send log ({sends.length})</div>
      <div className="space-y-1 max-h-40 overflow-y-auto text-[11px] font-mono">
        {sends.map((s) => (
          <div key={s.id} className="flex gap-2 text-slate-400" data-testid={`send-log-${s.id}`}><span className={s.ok ? "text-emerald-400" : "text-red-400"}>{s.ok ? "✓" : "✗"}</span><span className="text-slate-500">{new Date(s.sent_at).toLocaleString()}</span><span className="text-slate-200">{s.to}</span><span>{s.doc === "change_order" ? "COR" : "PM report"}{s.letter ? " + letter" : ""} · by {s.sent_by}</span></div>
        ))}
      </div>
    </div>
  );
}
